import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Calendar } from 'lucide-react';
import '../../Styles/yellowcalfcss/PayBill.css';
const billsList = [
  { id: 1, billNumber: 'wwxxzz', supplier: '', billDate: '2024-04-03', dueDate: '2024-04-14', paidAmount: 0, totalAmount: 0 },
  { id: 2, billNumber: 'wefg', supplier: '', billDate: '2024-05-23', dueDate: '2024-05-13', paidAmount: 0, totalAmount: 0 },
  { id: 3, billNumber: 'wefg', supplier: '', billDate: '2024-05-23', dueDate: '2024-05-13', paidAmount: 0, totalAmount: 20 }
];

export function PayBill() {
  const [paymentDate, setPaymentDate] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [totalAmountPayable, setTotalAmountPayable] = useState('20');

  const totalAmount = billsList.reduce((sum, bill) => sum + bill.totalAmount, 0);
  const paidAmount = billsList.reduce((sum, bill) => sum + bill.paidAmount, 0);
  const pendingAmount = totalAmount - paidAmount;

  const handleCreate = () => {
    console.log('Creating payment...');
    alert('Well done Bill Payment done successfully');
  };

  return (
    <div className="paybill-main-wrapper">
      <div className="paybill-content-container">
        <div className="paybill-section-gap">
          <Card className="paybill-title-card">
            <Card.Body>
              <h3 className="paybill-main-heading">Pay Bill</h3>
            </Card.Body>
          </Card>
        </div>

        <div className="paybill-section-gap">
          <Card className="paybill-form" >
            <Card.Body>
              <Container fluid>
                <Row>
                  <Col md={6}style={{marginLeft:'-45px', width:'400px',marginTop:'-30px'}}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">Payment Date</Form.Label>
                      <div className="paybill-calendar-wrapper">
                        <Form.Control
                          type="date"
                          value={paymentDate}
                          onChange={(e) => setPaymentDate(e.target.value)}
                          className="paybill-date-field"
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={6}style={{width:'400px',marginTop:'-30px'}}>
                    <Form.Group className="paybill-input-group">
                      <Form.Label className="paybill-label">
                        Bank <span className="paybill-mandatory">*</span>
                      </Form.Label>
                      <Form.Select
                        value={selectedBank}
                        onChange={(e) => setSelectedBank(e.target.value)}
                        className="paybill-bank-select"
                      >
                        <option value="">Select</option>
                        <option value="bank1">Shamnanda(438756475647)</option>
                        <option value="bank2">aksharban(75475647856478)</option>
                        <option value="bank3">akbarshan(848578475)</option>
                        <option value="bank4">sahensha(495844544)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
       

        <div className="paybill-section-gap">
          <div className="paybill-bills-collection">
            <Card className="paybill-table-header-card"style={{height:'60px'}}>
              <Card.Body className="paybill-table-header-body">
                <Row className="paybill-header-row"style={{marginTop:'-14px' }}>
                  <Col md={1} className="paybill-header-col" style={{textAlign:'center'}}>Sr No</Col>
                  <Col md={2} className="paybill-header-col" style={{textAlign:'center'}}>Bill Number</Col>
                  <Col md={2} className="paybill-header-col" style={{textAlign:'center'}}>Supplier</Col>
                  <Col md={2} className="paybill-header-col" style={{textAlign:'center'}}>Bill Date</Col>
                  <Col md={2} className="paybill-header-col" style={{textAlign:'center'}}>Due Date</Col>
                  <Col md={2} className="paybill-header-col" style={{textAlign:'center'}}>Paid Amount</Col>
                  <Col md={1} className="paybill-header-col" style={{textAlign:'center'}}>Total Amount</Col>
                </Row>
              </Card.Body>
            </Card>
            {billsList.map((bill) => (
              <Card key={bill.id} className="paybill-bill-row-card">
                <Card.Body className="paybill-bill-row-body" style={{height:'45px'}}>
                  <Row className="paybill-bill-row" style={{marginTop:'-10px'}}>
                    <Col md={1} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.id}</Col>
                    <Col md={2} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.billNumber}</Col>
                    <Col md={2} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.supplier || '-'}</Col>
                    <Col md={2} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.billDate}</Col>
                    <Col md={2} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.dueDate}</Col>
                    <Col md={2} className="paybill-bill-col" style={{textAlign:'center'}}>{bill.paidAmount}</Col>
                    <Col md={1} className="paybill-bill-col" style={{textAlign:'center'}}>
                      {bill.totalAmount === 0 ? '0' : `$ ${bill.totalAmount}`}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>

        <div className="paybill-section-gap">
          <Card className="paybill-summary-card" style={{height:'135px'}}>
            <Card.Body>
              <Container fluid>
                <Row>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group" style={{marginTop:'-13px', marginLeft:'30px'}}>
                      <Form.Label className="paybill-label" style={{marginTop:'-20px'}}>Total Amount Payable *</Form.Label>
                      <Form.Control
                        type="text"
                        value={totalAmountPayable}
                        onChange={(e) => setTotalAmountPayable(e.target.value)}
                        className="paybill-amount-input"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group" style={{marginTop:'-13px' , marginLeft:'210px'}}>
                      <Form.Label className="paybill-label" style={{marginTop:'-20px'}}>Pending Amount</Form.Label>
                      <div className="paybill-amount-display">
                        {pendingAmount} $
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="paybill-input-group" style={{marginTop:'-13px' , marginLeft:'230px'}}>
                      <Form.Label className="paybill-label" style={{marginTop:'-20px'}}>Paid Amount</Form.Label>
                      <div className="paybill-amount-display">
                        {paidAmount} $
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </div> </div>

        <div className="paybill-section-gap">
          <Card className="paybill-action-card" style={{height:'55px' , width:'90px' , marginTop:'10px' , marginLeft:'1120px'}}>
          
              <div className="paybill-button-wrapper">
                <Button onClick={handleCreate} className="paybill-submit-btn" style={{ height:'40px', marginTop:'10px' , marginLeft:'9px'}}>
                  Create
                </Button>
              </div>
       
          </Card>
        </div>
      </div>
    </div>
  );
}
